import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 border-t border-white/10 bg-black text-center text-gray-500 text-sm font-medium" data-id="element-110">
      <div className="max-w-4xl mx-auto space-y-4" data-id="element-111">
        <p className="text-gray-400 font-bold" data-id="element-112">
          ECONOMIA PRO™ — Il sistema N.1 per Docenti di Economia Aziendale
          nella Scuola Secondaria italiana.
        </p>
        <p data-id="element-113">
          Perché insegnare contabilità, bilanci e finanza aziendale non dovrebbe
          costarti ogni sera della settimana.
        </p>
        <p data-id="element-114">
          <a href="mailto:kitonline27@gmail.com" className="hover:text-brand-orange transition-colors" data-id="element-115">
            📧 kitonline27@gmail.com
          </a>
        </p>
        <p data-id="element-116">
          © ECONOMIA PRO™ Sistema Didattico Integrato 2026 — Tutti i diritti
          riservati.
        </p>
      </div>
    </footer>;
}